import React, { useContext } from "react";
import { Link } from "gatsby";
import { TransitionLink } from "gatsby-plugin-transition-link/components/TransitionLink";
import { Context as TransitionContext } from "gatsby-plugin-transition-link/context/createTransitionContext";

// Einheitlicher Seitenlink fuer Navigation, Banner, Footer und Inhalt.
//
// Der Vorhang (PageTransition) faehrt in 0.6 s. gatsby-plugin-transition-link
// sperrt nach jedem Klick saemtliche TransitionLinks fuer die Dauer von
// exit-Laenge bzw. entry-Verzoegerung + entry-Laenge (der groessere Wert).
// Ohne explizite entry-Laenge gilt dort 1 s - die Sperre dauerte dann 1,5 s,
// obwohl die neue Seite nach 1,1 s laengst frei zu sehen war.
export const PAGE_EXIT = { length: 0.5 };
export const PAGE_ENTRY = { delay: 0.5, length: 0.6 };

interface IPageLinkProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href"> {
  to: string;
  state?: object;
  activeClassName?: string;
  partiallyActive?: boolean;
}

const PageLink: React.FC<IPageLinkProps> = ({ to, children, ...rest }) => {
  const transition = useContext(TransitionContext);

  // Waehrend eines laufenden Seitenwechsels verwirft das Plugin jeden Klick
  // auf einen TransitionLink: erst preventDefault, dann return. Der Besucher
  // klickt also ins Leere, obwohl die Seite bedienbar aussieht. Solange
  // faellt der Link auf den normalen Gatsby-Link zurueck, der sofort
  // navigiert - ohne Vorhang, aber verlaesslich.
  if (transition && transition.inTransition) {
    return (
      <Link to={to} {...rest}>
        {children}
      </Link>
    );
  }

  return (
    <TransitionLink to={to} exit={PAGE_EXIT} entry={PAGE_ENTRY} {...rest}>
      {children}
    </TransitionLink>
  );
};

export default PageLink;
